import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import ScrollToTopPage from "./components/scroll-top-page";
import { AuthContextProvider } from "./context/AuthContext";
import "./fonts/yu-mincho/yumin.ttf";
import "./index.scss";
import RenderRouters from "./routers/renderRoutes";
import { store } from "./store";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <AuthContextProvider>
        <ScrollToTopPage>
          <RenderRouters />
        </ScrollToTopPage>
      </AuthContextProvider>
    </BrowserRouter>
  </Provider>
);
